import { getID } from "src/libs/utilities"
import { TAB_DESIGN_TYPE } from "../interfaces"

const horizontal_tab = () : any[] =>{
    return [
        {
            id: getID("horizontal_tab"),
            title: "Underline", 
            className: TAB_DESIGN_TYPE.NONE,
            classSource: "/assets/css/landing/tabs.scss",
            style: {},
            beforeStyle: {},
            afterStyle: {},
        },
        {
            id: getID("horizontal_tab"),
            title: "Porthole",  
            className: TAB_DESIGN_TYPE.PORTHOLE,
            classSource: "/assets/css/landing/tabs.scss",
            style: {},
            beforeStyle: {},
            afterStyle: {},
        },
        {
            id: getID("horizontal_tab"),
            title: "Capsule",  
            className: TAB_DESIGN_TYPE.CAPSULE,
            classSource: "/assets/css/landing/tabs.scss",
            style: {},
            beforeStyle: {},
            afterStyle: {},
        },
        {
            id: getID("horizontal_tab"),
            title: "Archive",  
            className: TAB_DESIGN_TYPE.ARCHIVE,
            classSource: "/assets/css/landing/tabs.scss",
            style: {},
            beforeStyle: {},
            afterStyle: {},
        },
        {
            id: getID("horizontal_tab"),
            title: "Anchors",  
            className: TAB_DESIGN_TYPE.ANCHORS,
            classSource: "/assets/css/landing/tabs.scss",
            style: {},
            beforeStyle: {},
            afterStyle: {},
        },
        {
            id: getID("horizontal_tab"),
            title: "Modern",  
            className: TAB_DESIGN_TYPE.MODERN,
            classSource: "/assets/css/landing/tabs.scss",
            style: {},
            beforeStyle: {},
            afterStyle: {},
        },
        {
            id: getID("horizontal_tab"),
            title: "Flap",  
            className: TAB_DESIGN_TYPE.FLAP,
            classSource: "/assets/css/landing/tabs.scss",
            style: {},
            beforeStyle: {},
            afterStyle: {},
        },
        {
            id: getID("horizontal_tab"),
            title: "o-la-la",  
            className: TAB_DESIGN_TYPE.O_LA_LA,
            classSource: "/assets/css/landing/tabs.scss",
            style: {},
            beforeStyle: {},
            afterStyle: {},
        },
        {
            id: getID("horizontal_tab"),
            title: "Pitaya",  
            className: TAB_DESIGN_TYPE.PITAYA,
            classSource: "/assets/css/landing/tabs.scss",
            style: {},
            beforeStyle: {},
            afterStyle: {},
        },
        {
            id: getID("horizontal_tab"),
            title: "Pitaya2",  
            className: TAB_DESIGN_TYPE.PITAYA2,
            classSource: "/assets/css/landing/tabs.scss",
            style: {},
            beforeStyle: {},
            afterStyle: {},
        },
        {
            id: getID("horizontal_tab"),
            title: "Folders",  
            className: TAB_DESIGN_TYPE.FOLDER,
            classSource: "/assets/css/landing/tabs.scss",
            style: {},
            beforeStyle: {},
            afterStyle: {},
        },
        {
            id: getID("horizontal_tab"),
            title: "Da Vinci",  
            className: TAB_DESIGN_TYPE.DA_VINCI,
            classSource: "/assets/css/landing/tabs.scss",
            style: {},
            beforeStyle: {},
            afterStyle: {},
        },
        {
            id: getID("horizontal_tab"),
            title: "Jnt capsule",  
            className: TAB_DESIGN_TYPE.JNT_CAPSULE,
            classSource: "/assets/css/landing/tabs.scss",
            style: {},
            beforeStyle: {},
            afterStyle: {},
        },
        {
            id: getID("horizontal_tab"),
            title: "Jnt limegreen",  
            className: TAB_DESIGN_TYPE.JNT_LIMEGREEN,
            classSource: "/assets/css/landing/tabs.scss",
            style: {},
            beforeStyle: {},
            afterStyle: {},
        },
        {
            id: getID("horizontal_tab"),
            title: "Jnt capsule",  
            className: TAB_DESIGN_TYPE.JNT_CAPSULE,
            classSource: "/assets/css/landing/tabs.scss",
            style: {},
            beforeStyle: {},
            afterStyle: {},
        },
        {
            id: getID("horizontal_tab"),
            title: "Sorax",  
            className: TAB_DESIGN_TYPE.SORAX,
            classSource: "/assets/css/landing/tabs.scss",
            style: {},
            beforeStyle: {},
            afterStyle: {},
        },
        {
            id: getID("horizontal_tab"),
            title: "Soap",  
            className: TAB_DESIGN_TYPE.SOAP,
            classSource: "/assets/css/landing/tabs.scss",
            style: {},
            beforeStyle: {},
            afterStyle: {},
        },
        {
            id: getID("horizontal_tab"),
            title: "Case",  
            className: TAB_DESIGN_TYPE.CASE,
            classSource: "/assets/css/landing/tabs.scss",
            style: {},
            beforeStyle: {},
            afterStyle: {},
        },
    ]
}
export default horizontal_tab